
import { Inject, Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { DomainObjectRepo } from '../../noizu/domain-object-repo';
import { FirebaseAuthService }        from '../../noizu/services/firebase-auth.service';
import { DataManufacturersEntity }      from '../../entities/data-manufacturers.entity';
import { AppengineRepo }      from '../appengine.repo';

@Injectable()
export class DataManufacturersRepo extends AppengineRepo {
  public _kind = "manufacturers";
  public _singular = "manufacturers";

  constructor(@Inject(HttpClient) client: HttpClient, @Inject(FirebaseAuthService) auth: FirebaseAuthService) {
    super(client, auth);
  }

  entity(record) {
    return new DataManufacturersEntity(this.client, this.auth, record)
  }
}
